import zonesSlice from './slice';

export const {
  setCollapse,
  setSelectedZone,
  setHoveredSafeLandZoneId,
  toggleCollapse,
  setZoneMapLocationUponCreation,
  setFreehandShapeUponCreation,
} = zonesSlice.actions;
